<script setup lang="ts">
import BaseDialog from "@/stories/dialogs/BaseDialog.vue";
import Button from "@/stories/buttons/Button/Button.vue";

interface Props {
  title: string;
  subtitle?: string;
  deleteTextKey?: string;
  cancelTextKey?: string;
}

withDefaults(defineProps<Props>(), {
  deleteTextKey: "global.delete",
  cancelTextKey: "templates.cancel",
});

defineEmits(["close", "approve"]);
</script>

<template>
  <BaseDialog v-if="true" @on-close="$emit('close')">
    <div class="overflow-hidden w-full text-center laptop:w-450 p-8">
      <div class="h800 text-neutral1000 mb-3">{{ title }}</div>
      <div
        v-if="subtitle"
        class="b300 mb-1 leading-6"
        v-html="$t('global.delete_title', { title: subtitle })"
      ></div>
      <slot></slot>
    </div>
    <div class="flex justify-between gap-3 py-4 px-6">
      <Button
        :fullWidth="true"
        :text="$t('templates.cancel')"
        type="white"
        @click="$emit('close')"
      />
      <Button
        :fullWidth="true"
        :text="$t(deleteTextKey)"
        :type="'error'"
        @click="$emit('approve')"
      />
    </div>
  </BaseDialog>
</template>
